import { render, staticRenderFns } from "./GroupHistory.vue?vue&type=template&id=12a8a54c"
import script from "./GroupHistory.vue?vue&type=script&lang=js"
export * from "./GroupHistory.vue?vue&type=script&lang=js"
import style0 from "./GroupHistory.vue?vue&type=style&index=0&id=12a8a54c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports